export function DiffCounts({ additions, deletions }: { additions: number; deletions: number }) {
  return (
    <>
      <span className="text-desktop-success">+{additions.toLocaleString()}</span>
      <span className="text-destructive">−{deletions.toLocaleString()}</span>
    </>
  );
}
